import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6aa058d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "form-group"
};
const _hoisted_2 = {
  class: "content"
};
import FormComponent from './component';
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue';
import { buildConfig, buildValues, buildRowProps, buildColProps } from './tools';
import { useFormStore } from '@/store/module/form';
import clone from 'lodash/cloneDeep';
function setup(__props, {
  expose
}) {
  const props = __props;
  // TODO pinia inject warning
  // TODO auto generate form rules
  const initialValues = props.values || buildValues(props.config);
  const formValues = reactive(clone(initialValues));
  const column = reactive(buildConfig(props.config));
  function getValues() {
    return formValues;
  }
  function initValues(val) {
    resetValues();
    Object.entries(val).forEach(([key, value]) => {
      formValues[key] = value;
    });
  }
  function resetValues() {
    Object.entries(initialValues).forEach(([key, value]) => {
      formValues[key] = value;
    });
  }
  expose({
    getValues,
    initValues,
    resetValues
  });
  onMounted(() => {
    const formStore = useFormStore();
    // 缓存实例 可以通过实例获取当前表单值
    formStore.set(props.config.id, getCurrentInstance());
  });
  onUnmounted(() => {
    const formStore = useFormStore();
    formStore.delete(props.config.id);
  });
  return (_ctx, _cache) => {
    const _component_el_form_item = _resolveComponent("el-form-item");
    const _component_el_col = _resolveComponent("el-col");
    const _component_el_row = _resolveComponent("el-row");
    const _component_el_form = _resolveComponent("el-form");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, _mergeProps({
      ref: (_value, _refs) => {
        _refs['form'] = _value;
      }
    }, _unref(column).formProps, {
      model: _unref(formValues)
    }), {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(column).rows, row => {
        return _openBlock(), _createBlock(_component_el_row, _mergeProps({
          key: row.id
        }, _unref(buildRowProps)(_unref(column).rowProps)), {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, col => {
            return _openBlock(), _createBlock(_component_el_col, _mergeProps({
              key: col.id
            }, _unref(buildColProps)(col.colProps)), {
              default: _withCtx(() => [_createVNode(_component_el_form_item, _mergeProps(col.formItemProps, {
                name: col.key
              }), {
                default: _withCtx(() => [_createVNode(_unref(FormComponent), {
                  col: col,
                  values: _unref(formValues)
                }, null, 8, ["col", "values"])]),
                _: 2
              }, 1040, ["name"])]),
              _: 2
            }, 1040);
          }), 128))]),
          _: 2
        }, 1040);
      }), 128))]),
      _: 1
    }, 16, ["model"])])]);
  };
}
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'CommonForm'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {
      type: null,
      required: true
    },
    values: {
      type: Object,
      required: false
    }
  },
  setup
});